import i18n from '@/translation/i18n';

const meeting = [
    { header: i18n.t('sheet.sheetOne.meeting.title'), name: 'sheet-one-meeting', number: 1 },
    {
        selector: 'instruction',
        name: i18n.t('sheet.sheetOne.meeting.instruction.title'),
        component: 'fillInstruction'
    },
    {
        selector: 'metrics',
        name: i18n.t('sheet.sheetOne.meeting.family_guide.title'),
        component: 'familyGuide'
    },
    {
        selector: 'previous-editions',
        name: i18n.t('sheet.sheetOne.meeting.previous_editions.title'),
        component: 'previousEditions'
    },
    {
        selector: 'history',
        name: i18n.t('sheet.sheetOne.meeting.family_history.title'),
        component: 'FamilyHistory'
    },
    {
        selector: 'resources',
        name: i18n.t('sheet.sheetOne.meeting.family_resources.title'),
        component: 'FamilyResources'
    },
    {
        selector: 'barriers',
        name: i18n.t('sheet.sheetOne.meeting.barriers.title'),
        component: 'QuestionsBarriers'
    },
    {
        selector: 'social_separation',
        name: i18n.t('sheet.sheetOne.meeting.social_separation.title'),
        component: 'SocialSeparation'
    },
    {
        selector: 'possessions',
        name: i18n.t('sheet.sheetOne.meeting.possessions.menuTitle'),
        component: 'QuestionsPossessions'
    },
    {
        selector: 'maintenanceExpenses',
        name: i18n.t('sheet.sheetOne.meeting.maintenance_expenses.title'),
        component: 'maintenanceExpenses'
    },
    {
        selector: 'expensesForMedicine',
        name: i18n.t('sheet.sheetOne.meeting.expenses_for_medicine.title'),
        component: 'ExpensesForMedicine'
    },
    {
        selector: 'doctorsPack',
        name: i18n.t('sheet.sheetOne.meeting.doctors_pack.title'),
        variable: true,
        component: 'DoctorsPack'
    },
    {
        selector: 'credits',
        name: i18n.t('sheet.sheetOne.meeting.credits.title'),
        component: 'QuestionsCredits'
    },
    { selector: 'lawyersPack', name: 'Paczka Prawników', variable: true, component: 'lawyersPack' },
    {
        selector: 'cashReceipts',
        name: i18n.t('sheet.sheetOne.meeting.cash_receipts.title'),
        component: 'CashReceipts'
    },
    {
        selector: 'jobless',
        name: i18n.t('sheet.sheetOne.meeting.jobless.title'),
        component: 'QuestionsJobless'
    },
    {
        selector: 'consents',
        name: i18n.t('sheet.sheetOne.meeting.consents.title'),
        component: 'SheetOneConsents'
    },
    {
        selector: 'volunteers',
        name: i18n.t('sheet.sheetOne.meeting.volunteers.title_short'),
        component: 'SheetOneVolunteers'
    }
];

const reflection = [
    { header: i18n.t('sheet.sheetOne.reflection.title'), name: 'sheet-one-reflection', number: 2 },
    { selector: 'calculation', name: i18n.t('sheet.sheetOne.reflection.calculation.title_short') },
    {
        selector: 'seniorReflection',
        name: i18n.t('sheet.sheetOne.reflection.senior.title'),
        variable: true
    },
    {
        selector: 'meetingSummary',
        name: i18n.t('sheet.sheetOne.reflection.meeting_summary.title_short')
    },
    { selector: 'reflectionBarriers', name: i18n.t('sheet.sheetOne.reflection.barriers.title') }
];

const decision = [
    { header: i18n.t('sheet.sheetOne.decision.title'), name: 'sheet-one-decision', number: 3 }
];

export default [meeting, reflection, decision];
